import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant';
import { onChange, setError, validateForm } from '../../utils';

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PASSWORD: { name: "PASSWORD", value: '', error: '', isRequired: true },
            CONFIRM_PASSWORD: { name: "CONFIRM_PASSWORD", value: '', error: '', isRequired: true },
            showPassword: false,
            ConfirmPassword: false
        }
    }

    onSubmit = (e) => {
        e.preventDefault()
        console.log(this.props)
        if (this.state.PASSWORD.value !== this.state.CONFIRM_PASSWORD.value) {
            setError(this, this.state.CONFIRM_PASSWORD.name, 'Confirm Password Must be Same')
            return false
        }

        if (validateForm(this)) {
            const model = {
                PASSWORD: this.state.PASSWORD.value

            }
            this.props.onSubmit(model)
        }
    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    /***Add By jitendra** */
    togglePasswordVisiblity = (e) => {
        this.setState({ showPassword: !this.state.showPassword })
    }
    /***End*** */
    render() {
        const { PASSWORD, CONFIRM_PASSWORD, showPassword, ConfirmPassword } = this.state;
        return (
            <React.Fragment>
                <section className="form-shared padding-top-150px padding-bottom-100px">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 mx-auto text-center">
                                <div className='forgot-password'>
                                    <img src={'./assets/images/forgot-pasword.png'} />
                                </div>
                            </div>
                            <div className="col-lg-6 mx-auto">
                                <div className="user-action-form">
                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade show active" id="signup-nav" role="tabpanel" aria-labelledby="signup-tab">
                                            <div className="billing-form-item mb-0">
                                                <div className="billing-title-wrap border-bottom-0">
                                                    <h3 className="widget-title font-size-28 pb-2">Reset Password</h3>
                                                </div>
                                                <div className="billing-content">
                                                    <div className="contact-form-action">
                                                        <form onSubmit={this.onSubmit}>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className="input-box">
                                                                        {/* <label className="label-text">Forgot Password</label> */}
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={PASSWORD.error.length ? "form-control is-invalid" : "form-control"}
                                                                                //type="password"
                                                                                type={showPassword ? 'text' : 'password'}
                                                                                name={PASSWORD.name}
                                                                                value={PASSWORD.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Enter New Password" />
                                                                            {/***Add By Jitender** */}
                                                                            {PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ showPassword: !showPassword }) }} className={showPassword ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}
                                                                            {/* <i className={(this.state.passwordShow) ? "fa fa-fw fa-eye toggle-password field-icon" : "fa fa-fw fa-eye-slash toggle-password field-icon"} onClick={(e) => this.togglePasswordVisiblity(e)}></i> */}
                                                                            {/****End** */}
                                                                        </div>
                                                                    </div>
                                                                    <div className="input-box">
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={CONFIRM_PASSWORD.error.length ? "form-control is-invalid" : "form-control"}
                                                                                //type="password"
                                                                                type={ConfirmPassword ? 'text' : 'password'}
                                                                                name={CONFIRM_PASSWORD.name}
                                                                                value={CONFIRM_PASSWORD.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Confirm New Password" />
                                                                            {/***Add By Jitender** */}
                                                                            {PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ ConfirmPassword: !ConfirmPassword }) }} className={ConfirmPassword ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}
                                                                            {/****End** */}
                                                                        </div>
                                                                    </div>
                                                                    <Link to={constant.component.login.url} className='font-size-12'>Go back to Employer's Login page</Link>
                                                                </div>
                                                            </div>
                                                            <div className="btn-box margin-top-30px">
                                                                <button className="theme-btn border-0" type="submit">Reset Password</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="section-block"></div>

            </React.Fragment>
        )
    }
}
